// React libraries
import React from 'react';

// Component Style
import Styled from './RadioStyles';

export const Radio = (props) => {
    const { id, type = "n900", name, value, label, disabled = false, style, checked, onChange = () => { } } = props;
    const onRadioClick = (id) => {
        document.getElementById(id).click()
    }

    return (
        <div 
            onClick={() => onRadioClick(`${name}-${value}`)}
            style={style} 
            id={id}
        >
            <Styled.Input>
                <input 
                    type="radio" 
                    name={name} 
                    id={`${name}-${value}`} 
                    value={value} 
                    disabled={disabled} 
                    onChange={onChange} 
                    checked={checked} 
                    htmlFor={`${name}-${value}`}
                />
            </Styled.Input>
            <Styled.Label
                type={type}
                disabled={disabled}
                checked={checked}
            >
                <label htmlFor={`${name}-${value}`}>
                    {label}
                </label>
            </Styled.Label>
        </div>
    );
};

export default React.memo(Radio);